'use client'
import React from 'react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'
import { text12px, text32px } from '@/app/utils'

interface SloganProps {}

export function Slogan({}: SloganProps) {
  const t = useTranslations('home.slogan')
  return (
    <div className={cn('bg-[#FFFFFF]')}>
      <div className={cn('container relative h-[20rem]')}>
        <div
          className={cn(
            'items-center flex flex-col justify-between mx-auto w-full h-full py-12 gap-4'
          )}
        >
          <div
            className={cn(
              text12px, 'items-center text-center justify-center text-[#444BD3] font-bold flex w-full h-full'
            )}
          >
            电话营销与客服
          </div>
          <div
            className={cn(
              text32px, 'items-center justify-center flex font-bold text-foreground dark:text-background/90 w-full h-full'
            )}
          >
            全自动AI呼叫中心
          </div>
          <div
            className={
              cn(text12px, 'text-[#7A7A86] items-center text-center justify-center text-foreground dark:text-background/80 flex w-full h-full')
            }
          >
            传统人工坐席模式在当前竞争激烈的市场生存难度陡增，人工效率及成本成为业务瓶颈。AI以高效、精准、低成本的优势，成倍扩大业务量，助力收入提升。
          </div>
        </div>
      </div>
    </div>
  )
}
